export enum SystemHealthStatus {
  OK = 'OK',
  DOWN = 'DOWN',
}

export interface SystemHealthEnvironmentStatus {
  environment: string;
  status: SystemHealthStatus;
}
